/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CategoryCategories} from './CategoryCategories';

/**
 * The Category model module.
 * @module model/Category
 * @version v1
 */
export class Category {
  /**
   * Constructs a new <code>Category</code>.
   * @alias module:model/Category
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Category</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Category} obj Optional instance to populate.
   * @return {module:model/Category} The populated <code>Category</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Category();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('image_url'))
        obj.image_url = ApiClient.convertToType(data['image_url'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('categories'))
        obj.categories = ApiClient.convertToType(data['categories'], [CategoryCategories]);
      if (data.hasOwnProperty('products'))
        obj.products = ApiClient.convertToType(data['products'], [CategoryCategories]);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
Category.prototype.id = undefined;

/**
 * @member {String} image_url
 */
Category.prototype.image_url = undefined;

/**
 * @member {String} name
 */
Category.prototype.name = undefined;

/**
 * @member {Array.<module:model/CategoryCategories>} categories
 */
Category.prototype.categories = undefined;

/**
 * @member {Array.<module:model/CategoryCategories>} products
 */
Category.prototype.products = undefined;

